(function (ng) {
    //service definition for orders in the system
    ng.module('evo.returns.initiate.services').factory('ordersService',
        ['$http', 'RETURNS_BASE',
            function ($http, RETURNS_BASE) {
                return {
                    findOrder: function (orderId, emailAddress) {
                        var params = {
                            emailAddress: emailAddress,
                            orderId: orderId
                        };
                        return $http.get(RETURNS_BASE + 'find-order', { params: params }).then(function (result) {
                            return result.data;
                        });
                    }
                };
            }
        ]);
})(angular);